import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4659f395"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-element-operate" }
const _hoisted_2 = ["width", "height", "stroke"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["x1", "y1", "x2", "y2"]
const _hoisted_5 = ["x1", "y1", "x2", "y2"]
const _hoisted_6 = ["x1", "y1", "x2", "y2"]
const _hoisted_7 = ["x1", "y1", "x2", "y2"]

import { computed, PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import { PPTLineElement } from '@/types/slides'
import { OperateLineHandlers } from '@/types/edit'

import ResizeHandler from './ResizeHandler.vue'


const __default__ = {
  inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'LineElementOperate',
  props: {
  elementInfo: {
    type: Object as PropType<PPTLineElement>,
    required: true,
  },
  handlerVisible: {
    type: Boolean,
    required: true,
  },
  dragLineElement: {
    type: Function as PropType<(e: MouseEvent, element: PPTLineElement, command: OperateLineHandlers) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { canvasScale } = storeToRefs(useMainStore())

const svgWidth = computed(() => Math.max(props.elementInfo.start[0], props.elementInfo.end[0]))
const svgHeight = computed(() => Math.max(props.elementInfo.start[1], props.elementInfo.end[1]))

const resizeHandlers = computed(() => {
  const handlers = [
    {
      handler: OperateLineHandlers.START,
      style: {
        left: props.elementInfo.start[0] * canvasScale.value + 'px',
        top: props.elementInfo.start[1] * canvasScale.value + 'px',
      }
    },
    {
      handler: OperateLineHandlers.END,
      style: {
        left: props.elementInfo.end[0] * canvasScale.value + 'px',
        top: props.elementInfo.end[1] * canvasScale.value + 'px',
      }
    },
  ]

  if (props.elementInfo.curve || props.elementInfo.broken) {
    const ctrlHandler = (props.elementInfo.curve || props.elementInfo.broken) as [number, number]

    handlers.push({
      handler: OperateLineHandlers.C,
      style: {
        left: ctrlHandler[0] * canvasScale.value + 'px',
        top: ctrlHandler[1] * canvasScale.value + 'px',
      }
    })
  }
  else if (props.elementInfo.cubic) {
    const [ctrlHandler1, ctrlHandler2] = props.elementInfo.cubic
    handlers.push({
      handler: OperateLineHandlers.C1,
      style: {
        left: ctrlHandler1[0] * canvasScale.value + 'px',
        top: ctrlHandler1[1] * canvasScale.value + 'px',
      }
    })
    handlers.push({
      handler: OperateLineHandlers.C2,
      style: {
        left: ctrlHandler2[0] * canvasScale.value + 'px',
        top: ctrlHandler2[1] * canvasScale.value + 'px',
      }
    })
  }

  return handlers
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.handlerVisible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resizeHandlers), (point) => {
            return (_openBlock(), _createBlock(ResizeHandler, {
              class: "operate-resize-handler",
              key: point.handler,
              style: _normalizeStyle(point.style),
              onMousedown: _withModifiers($event => __props.dragLineElement($event, __props.elementInfo, point.handler), ["stop"])
            }, null, 8, ["style", "onMousedown"]))
          }), 128)),
          (_openBlock(), _createElementBlock("svg", {
            width: _unref(svgWidth) || 1,
            height: _unref(svgHeight) || 1,
            stroke: __props.elementInfo.color,
            overflow: "visible",
            style: _normalizeStyle({ transform: `scale(${_unref(canvasScale)})` })
          }, [
            (__props.elementInfo.curve)
              ? (_openBlock(), _createElementBlock("g", _hoisted_3, [
                  _createElementVNode("line", {
                    class: "anchor-line",
                    x1: __props.elementInfo.start[0],
                    y1: __props.elementInfo.start[1],
                    x2: __props.elementInfo.curve[0],
                    y2: __props.elementInfo.curve[1]
                  }, null, 8, _hoisted_4),
                  _createElementVNode("line", {
                    class: "anchor-line",
                    x1: __props.elementInfo.end[0],
                    y1: __props.elementInfo.end[1],
                    x2: __props.elementInfo.curve[0],
                    y2: __props.elementInfo.curve[1]
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            (__props.elementInfo.cubic)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.elementInfo.cubic, (item, index) => {
                  return (_openBlock(), _createElementBlock("g", { key: index }, [
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("line", {
                          key: 0,
                          class: "anchor-line",
                          x1: __props.elementInfo.start[0],
                          y1: __props.elementInfo.start[1],
                          x2: item[0],
                          y2: item[1]
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    (index === 1)
                      ? (_openBlock(), _createElementBlock("line", {
                          key: 1,
                          class: "anchor-line",
                          x1: __props.elementInfo.end[0],
                          y1: __props.elementInfo.end[1],
                          x2: item[0],
                          y2: item[1]
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ], 12, _hoisted_2))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})